<template>
  <div class="w-per100 column a-center footerBox c_fff ft15">
    <!-- 拨打电话 -->
    <div class="w-per100 h160 bg_F97316 row flex-center">
      <img class="wh120 mr40" :src="iconKefu" alt="客服" />
      <div class="column a-center">
        <div class="c_fff ft18">
          我们专业的服务团队将第一时间与您取得联系，为您提供全方位、定制化的优质服务
        </div>
        <!-- <div class="row a-center mt20">
          <div class="bg_fff br4 px20 py6 c_F97316 ft16 mr20">拨打电话</div>
          <div class="bd_white br4 px20 py6 c_fff ft16">{{ phone }}</div>
        </div> -->
      </div>
    </div>
    <!-- 底部导航栏 -->
    <div class="w-per100 h352 bg_292C3E column j-sb a-center">
      <div class="w-per62_5 h-per100 column a-center">
        <div class="w-per100 mt30">
          <img class="logoimg1" :src="logo" alt="" />
        </div>
        <div class="w-per100 flex1 row j-sb mt32">
          <div class="flex1 row">
            <ul
              class="column mr100"
              v-for="(item, index) in list"
              :key="item.id"
            >
              <li class="pointer c_fff ft16" @click="scrollTo(index,item.catname)">{{ item.catname }}</li>
              <li class="ft13 pointer mt17 c_999" v-for="(ite,ind) in item.child" :key="ind" @click="scrollTo(index,ite.catname,ind)">{{ ite.catname }}</li>
            </ul>
          </div>
          <div class="column a-center">
            <img class="wh86" src="@/assets/image/ewm2.jpg" alt="" />
            <div class="c_fff ft12 mt12">知汇享</div>
          </div>
          <div class="column a-center ml40">
            <img class="wh86" src="@/assets/image/ewm1.jpg" alt="" />
            <div class="c_fff ft12 mt12">讯享家</div>
          </div>
        </div>
        <div class="ft13 mb20 c_fff row flex_center">
          <a href="https://beian.miit.gov.cn" target="_blank">{{ icp }}</a>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import {getConfig} from "@/api/app"
import iconKefu from "@/assets/image/icon_kefu.png"
export default {
  data() {
    return {
      list: [],
      logo: "",
      icp: "",
      erImgTwo: "",
      phone: "",
      iconKefu,
    }
  },
  props: {
    current: Number,
  },
  mounted() {
    this.list = [
        {
          catname:'首页',
          child:[
          {
            catname:'我们的优势'
          },
          {
            catname:'期待合作'
          },
          ]
        },
        {
          catname:'营销传播',
          child:[
            {
              catname:'在线培训'
            },
            {
              catname:'网络推广'
            },
            {
              catname:'市场调研'
            },
          ]
        },
        {
          catname:'活动策划',
          child:[
            {
              catname:'多元活动'
            },
            {
              catname:'我们的优势'
            },
          ]
        },
        {
          catname:'综合服务',
          child:[
            {
              catname:'汽车展览'
            },
            {
              catname:'主题会议'
            },
            {
              catname:'社区活动'
            },
          ]
        },
        {
          catname:'关于我们',
          child:[
            {
              catname:'公司介绍'
            },
            {
              catname:'联系我们'
            },
          ]
        },
      ]
    this.fetchConfig()
  },
  methods: {
    scrollTo(num,text,li) {
      console.log(num,text,li)
      let data = {}
      if (num == this.current) {// 本页面滚动
        if (text == "首页" && li==undefined) {
          data.num = 0
        } else if (text == "营销传播" && li==undefined) {
          data.num = 1
        } else if (text == "活动策划" && li==undefined) {
          data.num = 2
        } else if (text == "综合服务" && li==undefined) {
          data.num = 3
        } else if (text == "关于我们" && li==undefined) {
          data.num = 4
        } else {
          data.num = -1
          // num=0
          if (text == "我们的优势") {
            data.id = "index1"
          }
          if (text == "期待合作") {
            data.id = "contactUs"
          }
          // num=1
          if (text == "在线培训") {
            data.id = 'service2'
          }
          if (text == "网络推广") {
            data.id = 'service3'
          }
          if (text == "市场调研") {
            data.id = 'service4'
          }
          // num=2
          if (text == "多元活动") {
            data.id = 'activity1'
          }
          if (text == "我们的优势") {
            data.id = 'activity2'
          }
          // num=3
          if (text == "汽车展览") {
            data.id = 'overall1'
          }
          if (text == "主题会议") {
            data.id = 'overall2'
          }
          if (text == "社区活动") {
            data.id = 'overall3'
          }
          // num=4
          if (text == "公司介绍") {
            data.id = "about1"
          }
          if (text == "联系我们") {
            data.id = "contactUs"
          }
        }
        data.offset = -88
      } else {
        // 跳转路由
        data.num = num;
        data.offset = -88
        // num=0
        switch (num){
          case 0:
            if (text == "我们的优势") {
              data.id = "index1"
            }
            if (text == "期待合作") {
              data.id = "contactUs"
            }
            break;
          case 1:
            if (text == "在线培训") {
              data.id = 'service2'
            }
            if (text == "网络推广") {
              data.id = 'service3'
            }
            if (text == "市场调研") {
              data.id = 'service4'
            }
            break;
          case 2:
            if (text == "多元活动") {
              data.id = "activity1"
            }
            if (text == "我们的优势") {
              data.id = "activity2"
            }
            break;
          case 3:
            if (text == "汽车展览") {
              data.id = "overall1"
            }
            if (text == "主题会议") {
              data.id = "overall2"
            }
            if (text == "社区活动") {
              data.id = "overall3"
            }
            break;
          case 4:
            if (text == "公司介绍") {
              data.id = "about1"
            }
            if (text == "联系我们") {
              data.id = "contactUs"
            }
            break;
          default:
            break;
        }
      }
      console.log("data", data)
      this.$emit("onScrollTo", data)
    },
    async fetchConfig() {
      let params = {name: 'bottom_logo,web_site_icp,er_img_two,phone'}
      let {data} = await getConfig(params)
      this.logo = data.data.list.bottom_logo;
      this.icp = data.data.list.web_site_icp;
      this.erImgTwo = data.data.list.er_img_two;
      this.phone = data.data.list.phone;
    },
  },
}
</script>
<style lang="scss" scoped>
.footerBox {
  a{
    color: white;
    text-decoration: none;
  }
  a:link{
    color:white;
  }
  a:visited{
    color:white;
  }
  a:hover{
    color:white;
  }
  a:active{
    color:white;
  }
}
.logoimg1{
  width: 140px;
  height: 60px;
}
</style>
